import { Dialog, DialogContent, DialogTitle } from "@workspace/web-ui/components/dialog"
import { NoteForm } from "../form/note-form";
import { Button } from "@workspace/web-ui/components/button";
import { RefreshCw } from "lucide-react";
import { useState, useEffect } from "react"; 
// import { ICD10Form } from "../form/icd10-form";


interface ViewNotesModalProps {
    data?: any;
    patientId: string;
    open: boolean;
    handleGenerateNotes: (icd10Code?: string, isRegenerate?: boolean) => void;
    isPending: boolean;
    onOpenChange: (open: boolean) => void;
    onSubmit?: (data: { icd10_code?: string }) => void;
    isLoading?: boolean;
    isGenerateFlow?: boolean;
    icd10Code?: string;
}


export const ViewNotesModal = ({ data, patientId, open, onOpenChange, handleGenerateNotes, isPending }: ViewNotesModalProps) => {
    const isEditing = !!data;
    const [selectedICD10Code, setSelectedICD10Code] = useState<string | undefined>(undefined);

    // Reset selected code when modal opens
    useEffect(() => {
        if (open) {
            setSelectedICD10Code(undefined);
        }
    }, [open]);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="w-full max-w-[550px] h-[85vh] flex flex-col p-0 overflow-hidden">
                <DialogTitle></DialogTitle>
                <div className="shrink-0 px-6 pt-10 pb-3 flex w-full items-center justify-between">
                    <h2 className="text-2xl font-medium">{isEditing ? 'Edit Notes' : 'Add Notes'}</h2>
                    {isEditing && (
                    <Button
                        className="button-primary !bg-[#4272DD] !text-white flex gap-2 items-center !shadow-none w-fit !border-none disabled:opacity-50 disabled:cursor-not-allowed"
                        onClick={() => handleGenerateNotes(selectedICD10Code, true)}
                        disabled={isPending || !selectedICD10Code}
                    >
                        <RefreshCw className={`w-4 h-4 text-white ${isPending ? 'animate-spin' : ''}`} />
                        {isPending ? 'Regenerating...' : 'Regenerate'}
                    </Button>
                    )}
                </div>
                <div className="flex-1 min-h-0 overflow-y-auto">
                    <div className="flex flex-col">
                        <NoteForm data={data} patientId={patientId} onOpenChange={onOpenChange} submitText={isEditing ? 'Update' : 'Submit'} isEditing={isEditing} onICD10CodeChange={setSelectedICD10Code}/>
                        {/* {isEditing && (
                         <div className="border-t">
                             <ICD10Form 
                                onSubmit={onSubmit} 
                                onCancel={() => onOpenChange(false)} 
                                isLoading={isLoading} 
                                isEditing={isEditing}
                             />
                         </div>
                        )} */}
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    )
}


